import { FC, useEffect } from 'react';
import { cn, isTelegramWebApp } from '@/shared/lib';
import { useScreenWidth } from '@/shared/hooks';
import { useTranslation } from 'react-i18next';
import { Modal, Typography } from '@/shared/components';
import { AddressViewContent } from './AddressViewContent';
import { useAppDispatch, useAppSelector, closeAddressViewModal } from '@/app/store';

export const AddressViewModal: FC = () => {
  const dispatch = useAppDispatch();
  const isTgWebApp = isTelegramWebApp();
  const { isDesktop } = useScreenWidth();
  const { t: tAddress } = useTranslation('address');
  const { isOpen, address, lat, lng, areManualCoordinates } = useAppSelector(
    (state) => state.application.addressViewModal,
  );

  useEffect(() => {
    if (!isOpen || isTgWebApp) return;
    window.history.pushState({ addressViewModal: true }, '');
    const onPopState = () => dispatch(closeAddressViewModal());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [isOpen, dispatch, isTgWebApp]);

  if (!isOpen) return null;

  const onClose = () => dispatch(closeAddressViewModal());
  const content = (
    <AddressViewContent
      address={address}
      lat={lat}
      lng={lng}
      areManualCoordinates={areManualCoordinates}
      onClose={onClose}
      isModal={isDesktop}
    />
  );

  if (isDesktop) {
    return (
      <Modal
        onClose={onClose}
        isDialog
        contentClassName='max-w-[868px] h-[708px] max-h-[90dvh] overflow-hidden flex flex-col px-0 pt-6 pb-0'
      >
        <Typography variant='h2' className='px-6 font-medium'>
          {tAddress('modal.viewTitle')}
        </Typography>
        <div className='flex-1 min-h-0'>{content}</div>
      </Modal>
    );
  }

  return (
    <div className={cn('fixed inset-0 z-[11] bg-background', isTgWebApp && 'mt-full-screen-header pb-2')}>
      {content}
    </div>
  );
};
